(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadora-home-redirect"]) return;
  try {
    
const nadoraLegacy=document.querySelector('[data-nadora-home-redirect]');
if(nadoraLegacy&&!window.Shopify?.designMode){
 const link=nadoraLegacy.querySelector('[data-redirect-home]');
 const destination=new URL(link.href,location.href),current=new URL(location.href);
 for(const key of ['pb','utm_source','utm_medium','utm_campaign','utm_content','utm_term'])if(current.searchParams.has(key))destination.searchParams.set(key,current.searchParams.get(key));
 if(['#product-specs','#faq','#purchase-options','#reviews'].includes(current.hash))destination.hash=current.hash;
 location.replace(destination.href);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadora-native-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-native-reviews]').forEach(function(section){
 const cards=[...section.querySelectorAll('[data-native-review]')],more=section.querySelector('[data-native-more]'),status=section.querySelector('[data-native-review-status]');
 if(more)more.addEventListener('click',function(){const hidden=cards.filter(card=>card.hidden),first=hidden[0];hidden.slice(0,6).forEach(card=>card.hidden=false);more.hidden=!cards.some(card=>card.hidden);const shown=cards.filter(card=>!card.hidden).length;status.textContent=status.dataset.statusFormat.replace('[shown]',shown).replace('[total]',cards.length);if(first){first.setAttribute('tabindex','-1');first.focus({preventScroll:true});}});
 document.querySelectorAll('[data-nadora-rating-slot]').forEach(function(slot){const link=document.createElement('a');link.href='#reviews';link.className='nadora-native-rating-link';link.textContent=section.dataset.ratingSummary;slot.replaceChildren(link);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadora-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
 function submit(area){
  const email=area.querySelector('[data-signup-email]');const consent=area.querySelector('[data-signup-consent]');
  const error=area.querySelector('[data-signup-error]');const success=area.querySelector('[data-signup-success]');
  const validEmail=email.checkValidity();const validConsent=consent.checked;
  email.setAttribute('aria-invalid',String(!validEmail));consent.setAttribute('aria-invalid',String(!validConsent));
  error.hidden=validEmail&&validConsent;success.hidden=!(validEmail&&validConsent);
  if(!validEmail){error.textContent=area.dataset.emailError;email.focus();return;}
  if(!validConsent){error.textContent=area.dataset.consentError;consent.focus();return;}
  email.value='';consent.checked=false;
 }
 document.addEventListener('click',function(event){const button=event.target.closest('[data-signup-button]');if(button)submit(button.closest('[data-signup-preview]'));});
 document.addEventListener('keydown',function(event){if(event.key==='Enter'&&event.target.matches('[data-signup-email]')){event.preventDefault();submit(event.target.closest('[data-signup-preview]'));}});
 document.addEventListener('input',function(event){
  const area=event.target.closest('[data-signup-preview]');if(!area)return;
  event.target.removeAttribute('aria-invalid');area.querySelector('[data-signup-error]').hidden=true;area.querySelector('[data-signup-success]').hidden=true;
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadora-structure-explorer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const control=event.target.closest('[data-structure-control]');
  if(!control)return;
  const section=control.closest('[data-structure-explorer]');
  if(!section)return;
  const selected=control.dataset.structureControl;
  section.querySelectorAll('[data-structure-control]').forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.structureControl===selected));});
  section.querySelectorAll('[data-structure-panel]').forEach(function(panel){panel.hidden=panel.dataset.structurePanel!==selected;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillora-fit-check"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){const input=event.target.closest('[data-fit-check] input[type="radio"]');if(!input)return;const section=input.closest('[data-fit-check]');section.querySelector('[data-fit-result]').textContent=input.closest('label').querySelector('span').textContent.trim()+' — '+input.dataset.positionNote;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillora-header"] && !Shopify.designMode) return;
  try {
    
const nadoraHeaderOffer=document.querySelector('.header-cta');
const nadoraPagePacks=document.querySelector('[data-nadora-packs]');
if(nadoraHeaderOffer&&nadoraPagePacks){
 nadoraHeaderOffer.href='#'+nadoraPagePacks.id;
 nadoraHeaderOffer.addEventListener('click',function(event){const input=nadoraPagePacks.querySelector('input:checked');if(input){event.preventDefault();input.focus({preventScroll:true});input.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}});
}

document.addEventListener('keydown', function(event) {
 if(event.key !== 'Escape') return;
 document.querySelectorAll('.mobile-menu[open]').forEach(function(menu) {menu.open=false;menu.querySelector('summary').focus();});
});
document.addEventListener('click', function(event) {
 document.querySelectorAll('.mobile-menu[open]').forEach(function(menu) {if(!menu.contains(event.target))menu.open=false;});
});
document.querySelectorAll('.site-header nav a').forEach(function(link) {
 link.addEventListener('click',function(){document.querySelectorAll('.mobile-menu[open]').forEach(menu=>menu.open=false);});
 const destination=new URL(link.href,window.location.href);const current=new URL(window.location.href);
 if(destination.pathname===current.pathname && destination.searchParams.get('view')===current.searchParams.get('view') && !destination.hash)link.setAttribute('aria-current','page');
});

  } catch(e) { console.error(e); }
})();
})();
